module.exports = __webpack_public_path__ + "img/lg_ring_g_s_null_0@2x.9f47e4aa.png";